import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { appointmentClientList_ } from "store/services/appointmentService";

import { ReactComponent as OTick } from "Assets/Images/icn/OrangeTick.svg";
import { FULL_NAME } from "helpers/common";

const NewConversationPopup = ({ isLoading, showPopup, handleClose, handleSubmit }) => {
  const dispatch = useDispatch();
  const [clientList, setClientList] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    if(!clientList?.length) {
      getClientList();
    }

    return () => {
      setClientList(null);
    }
  }, []);

  async function getClientList() {
    try {
      let res = await dispatch(appointmentClientList_());
      setClientList(res?.body)
    } catch (err) {
      console.log(err);
    }
  }

  const onClose = () => {
    handleClose();
  }

  const handleSelectClient = (event) => {
    let { value } = event.target;
    value = Number(value);
    setSelectedClient(value);
  };

  return (
    <>
      <Modal
        show={showPopup}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        centered
        className="FormPop"
      >
        <Modal.Header closeButton>
          <Modal.Title>Start a New Conversation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12">
              <div className="py-2">
                <p className="m-0">
                  Select clients to start a conversation:
                </p>
                {clientList?.length > 0 && (
                  <ul className="list-unstyled px-2 pt-2">
                    {clientList?.map((client, index) => (
                      <li key={index}>
                        <div className="py-2 d-flex align-items-start gap-10">
                          <div className="cstmInputCheckWrp position-relative checkbox">
                            <input
                              type="radio"
                              className="position-absolute w-100 h-100"
                              value={client.id}
                              checked={selectedClient === client.id}
                              onChange={handleSelectClient}
                            />
                            <div className="cstmInputCheck h-100 w-100  d-flex align-items-center justify-content-center">
                              <span className="icn d-none ">
                                <OTick />
                              </span>
                            </div>
                          </div>
                          <p className="m-0">{FULL_NAME(client.first_name, client.last_name)} ({client.email})</p>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="FormbtnWrpper justify-content-end d-flex gap-10">
          <Button
            className="d-flex align-items-center justify-content-center commonBtn btnSm"
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            className="d-flex align-items-center justify-content-center commonBtn btnSm"
            onClick={() => handleSubmit(selectedClient)}
            disabled={isLoading || !selectedClient}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewConversationPopup;
